// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rLs1","name":"styles_name__3oiZm","phone":"styles_phone__2SUSf"};